export const SIDEBAR_TO_IFRAME_SECTION_ID = {
  SUBDOMAIN: "subdomain",
  COVER: "cover",
  ABOUT_YOU: "about-me",
  ABOUT_SECTION: "about-section",
  OFFERINGS_SECTION: "offerings",
  INTRO_VIDEO: "intro-video",
  SOCIAL: "social",
  AWARDS: "awards",
  BRAND_COLLABORATIONS: "brand-collaborations",
  MEDIA_MENTIONS: "media-mentions",
  CONTACT_DETAILS: "contact",
  TESTIMONIALS: "testimonials",
  GALLERY: "portfolio",
  FEATURES: "features",
  ADDITIONAL_POINTERS: "additional-pointers",
  BLOGS: "blogs",
  TEAMS: "teams",
  STATISTICS: "statistics",
  LOGO: "logo",
  COLORS: "colors",
  CUSTOM_FOOTER: "custom-footer",
};

export const TEAMS_FIELDS_CONFIG = {
  DEFAULT: {
    section_name: true,
    heading: true,
    description: true,
  },

  CLASSIC: {
    section_name: true,
    heading: false,
    description: false,
  },

  SUCCESS: {
    // eduverse
    section_name: true,
    heading: false,
    description: false,
  },

  GROWTH: {
    section_name: true,
    heading: false,
    description: false,
  },

  MODERN: {
    section_name: true,
    heading: false,
    description: false,
  },

  SWIFT: {
    // yoga
    section_name: true,
    heading: false,
    description: false,
  },
};

export const SCROLL_TO_SECTION = "scroll_to_section";
